export const enum UsersEndpoints {
  USERS = '/users',
  ORGANIZATIONS = 'api/v1/organizations'
}
